import styled from 'styled-components';

const IconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #FF9900;  // Cor laranja oficial da AWS
  
  svg {
    width: 1em;
    height: 1em;
    transform: translateY(0.2em); // Adicionado deslocamento vertical
  }
`;

export const AthenaIcon = () => (
  <IconWrapper>
    <svg viewBox="0 0 24 28" fill="currentColor">
      {/* Base */}
      <path d="M2 22h20v4H2z" opacity="0.8"/>
      
      {/* Barras 3D */}
      <path d="M3 17h3v5H3z"/>
      <path d="M7 14h3v8H7z"/>
      <path d="M11 19h3v3h-3z"/>
      <path d="M15 12h3v10h-3z"/>
      <path d="M19 16h3v6h-3z"/>
      
      {/* Sombras para efeito 3D */}
      <path d="M3 17h3l1-1H4z" opacity="0.2"/>
      <path d="M7 14h3l1-1H8z" opacity="0.2"/>
      <path d="M11 19h3l1-1h-3z" opacity="0.2"/>
      <path d="M15 12h3l1-1h-3z" opacity="0.2"/>
      <path d="M19 16h3l1-1h-3z" opacity="0.2"/>
    </svg>
  </IconWrapper>
); 